export const actions = {
  SET_USER_DATA: 'SET_USER_DATA',
  SET_CHARITY_DATA: 'SET_CHARITY_DATA',
  SET_CHARITY_OVERRIDE: 'SET_CHARITY_OVERRIDE',
  REMOVE_CHARITY_OVERRIDE: 'REMOVE_CHARITY_OVERRIDE',
  SET_USER_TOKEN: 'SET_USER_TOKEN'
}